'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { useWindowScroll } from '@uidotdev/usehooks';
import clsx from 'clsx';
import Link from 'next/link';
import { FrachterLogo } from '@/components/frachter-logo';
import s from './nav-bar.module.scss';
export const NavBar = () => {
  const $ = _c(11);
  const [t0] = useWindowScroll();
  const {
    y
  } = t0;
  const t1 = (y ?? 0) > 150 && s.withBackground;
  let t2;
  if ($[0] !== t1) {
    t2 = clsx(s.root, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      justifySelf: "start"
    };
    t4 = <FrachterLogo />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Group gap="xs" style={t3}>{t4}<Stack gap={0}><Text fw={800} lh={1}>frachter</Text><Text fw={500} size="xs">Let us do the heavy lifting</Text></Stack></Group>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      justifySelf: "center"
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Text style={t6} visibleFrom="sm"><strong style={{
        color: "var(--color-brand-secondary)"
      }}>QuickShip</strong> by frachter</Text>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignItems: "center",
      display: "grid",
      gap: "1rem",
      gridTemplateColumns: "auto auto",
      justifySelf: "end"
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Box className={s.content}>{t5}{t7}<Box style={t8}><Button color="var(--color-brand)" component={Link} href="/auth/sign-in" style={{
          justifySelf: "end"
        }} variant="outline">Login</Button></Box></Box>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t2) {
    t10 = <Box className={t2} component="nav" px="md" py="md">{t9}</Box>;
    $[9] = t2;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};